export const menuItems = [
    {
        id: 1,
        label: 'Orders',
        link: '/orders',
        /*
        label: 'menuitems.dashboards.text',
        subItems: [
            {
                id: 2,
                label: 'Orders',
                link: '/orders',
                parentId: 1
            },
        ]
         */
    },
];

